var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('svg-icon',{attrs:{"icon-class":"file-transfer-close"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }